<template>
  <div class="down-popover">
    <el-popover
      :value="isShow"
      :placement="placement"
      :width="width"
      :trigger="trigger"
      @show="show"
      @after-enter="afterEnter"
      @hide="hide"
      @after-leave="afterLeave"
    >
      <div class="down-hint" :style="{'max-height':maxHeight+'px'}">
        <p class="tip" v-if="length===0">暂无数据</p>
        <ul v-else>
          <li
            class="down-item"
            v-for="item in data"
            :key="item[keyName]"
            @click="handleritem(item)"
          >
            <label v-cloak>{{item[labelName]}}</label>
            <el-progress
              v-if="item.progressStatus ==='text'"
              class="down-progress"
              :percentage="item.progress"
            ></el-progress>
            <el-progress
              v-else
              class="down-progress"
              :percentage="item.progress"
              :status="item.progressStatus"
            ></el-progress>
            <el-button
              class="down-btn"
              :disabled="!item.isDown"
              type="text"
              @click.stop="handlerdown(item)"
            >下载</el-button>
          </li>
        </ul>
      </div>
      <el-button
        :type="buttonClass.type"
        :plain="buttonClass.plain"
        :round="buttonClass.round"
        slot="reference"
      >{{title}}</el-button>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'downHint',
  props: {
    width: {
      type: Number,
      default: 260
    },
    maxHeight: {
      type: Number,
      default: 80
    },
    isShow: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'left-start'
    },
    buttonClass: {
      type: Object,
      default() {
        return {
          type: 'info',
          plain: false,
          round: false
        }
      }
    },
    trigger: {
      type: String,
      default: 'click'
    },
    title: {
      type: String,
      default: ''
    },
    labelName: {
      type: String,
      default: 'name'
    },
    keyName: {
      type: String,
      default: 'id'
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    show: Function,
    afterEnter: Function,
    hide: Function,
    afterLeave: Function
  },
  data() {
    return {}
  },
  computed: {
    length() {
      return this.data.length
    }
  },
  methods: {
    handlerdown(item) {
      this.$emit('clickDown', item)
    },
    handleritem(item) {
      this.$emit('clickItem', item)
    }
  }
}
</script>

<style lang="less">
.down-popover {
  display: inline-block;
}
.down-hint {
  overflow-y: auto;
  padding-right: 5px;
  /*滚动条样式*/
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #409eff;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  > .tip {
    text-align: center;
    padding: 10px 0;
  }
  .down-item {
    display: flex;
    height: 30px;
    > label {
      padding-right: 5px;
      line-height: 30px;
    }
    > .down-progress {
      flex: 1;
      margin-top: 7px;
      .el-progress-bar {
        padding-right: 45px;
        margin-right: -42px;
      }
      .el-progress__text {
        font-size: 12px !important;
        margin-left: 0;
      }
    }
    > .down-btn {
      width: 30px;
      padding: 0;
    }
  }
}
[v-cloak] {
  display: none;
}
</style>
